import React from 'react';

import './styles/sgu-tokens.css';
import './index.css';
import './styles/SguPageShell.css';
import './polyfills/chartjsPolyfill';
import 'bootstrap/dist/css/bootstrap.min.css';

import App from './App';
import ReactDOM from 'react-dom/client';

import { ThemeProvider } from 'react-bootstrap';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';
import { UserProvider } from './hooks/UserProvider';
import { isCryptoAvailable } from './polyfills/cryptoPolyfill';
import CryptoRequiredNotice from './components/CryptoRequiredNotice/CryptoRequiredNotice';

const root = ReactDOM.createRoot(document.getElementById('root'));

const renderApp = content => {
  root.render(
    <ThemeProvider breakpoints={['xxxl', 'xxl', 'xl', 'lg', 'md', 'sm', 'xs', 'xxs']}>
      {content}
    </ThemeProvider>
  );
};

if (!isCryptoAvailable()) {
  renderApp(<CryptoRequiredNotice />);
} else {
  const msalInstance = new PublicClientApplication(msalConfig);
  renderApp(
    <MsalProvider instance={msalInstance}>
      <UserProvider>
        <App />
      </UserProvider>
    </MsalProvider>
  );
}
